import React, { useState }  from "react"
import axios from "axios";
import styled from 'styled-components';
import toast, { Toaster } from 'react-hot-toast';
import Layout from "../components/layout"
import Seo from '../components/seo';


const ContactWrapper = styled.div`
  max-width: 1200px;
  position: relative;
  margin: auto;
  padding: 70px 15px 0;
  @media (max-width: 990px) {
    padding: 70px 15px 30px;
  }
  @media (max-width: 575px) {
    padding: 60px 15px 0;
  }
`;


const ContactPageTitle = styled.div`
  margin-bottom: 45px;
  text-align: center;
  @media (max-width: 767px) {
    margin-bottom: 30px;
  }
  p {
    color: #757575;
  }

  h1{
    font-family: var(--title-font);
    font-size: 58px;
    font-weight: 600;
    letter-spacing: -1.5px;
    line-height: 1.3;
    margin-bottom: 40px;

    @media (max-width: 990px) {
      font-size: 37px;
    }
    @media (max-width: 767px) {
      font-size: 35px;
      margin-bottom: 10px;
    }
  }
`;

const StyledContactForm = styled.div`
  margin: auto;

  form{
    max-width:700px;
    margin: auto;
  }
  
   input[name=name],input[name=email],textarea{
    border: 1px solid #ccc;
    font-family: var(--body-font);
    float: left;
    height: 45px;
    margin-bottom: 40px;
    padding-left: 15px;
    width: 47.5%;
    -webkit-appearance: textfield;
}
@media (max-width: 970px){
     margin-left: 30px;
    margin-right: 30px;
input[name=name], input[name=email],textarea {
    float: none;
    width: 100%;
    margin-bottom: 20px;
}

}
  input[name=name] {
    margin-right: 5%;
}
textarea {
    border: 1px solid #ccc;
    font-family: var(--body-font);
    height: 170px;
    letter-spacing: .5px;
    line-height: 2;
    margin-bottom: 40px;
    padding: 15px;
    width: 100%;
    @media (max-width: 970px){
    
    margin-bottom: 20px;
  }
}
button {
    cursor: pointer;
    font-family: var(--title-font);
    transition: all .2s ease-in-out;
    background: #000;
    border: 1.5px solid #000;
    color: #fff;
    display: block;
    font-size: 13px;
    font-weight: 600;
    height: 55px;
    line-height: 53px;
    letter-spacing: 3px;
    text-align: center;
    text-transform: uppercase;
    width: 220px;
    @media (max-width: 500px){
      width: 100%;
    }
}
.btn.disable span{
   display: block;
}
.btn.active span{
  display:none;
}
.btn.disable svg{
   display: none;
}
.btn.active svg{
  display:block;
}
`;



const ContactPage = ({ location }) => {

  const [Loading, setLoading] = useState(false);

const LoadingIcon = (props) => {

    return (
    
    <svg className = {props.Style} xmlns="http://www.w3.org/2000/svg"  x="0px" y="0px" width="40px" height="40px" viewBox="0 0 50 50" >
    <path fill="#fff" d="M25.251,6.461c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615V6.461z">
      <animateTransform attributeType="xml" attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="0.6s" repeatCount="indefinite"></animateTransform>
      </path>
    </svg>

    );
  };
   
    
    const handleOnSubmit = e => {
      setLoading(true);
      e.preventDefault();
      const form = e.target;
      axios({
        method: "post",
        url: process.env.CONTACT_FORM_KEY,
        data: new FormData(form)
      })
        .then(r => {
          //setFormStatus(true);
          toast.success('your message was sent!');
          setLoading(false);

          form.reset();

        })
        .catch(r => {
          console.log(r.response.data.error);
          toast.success('your message dosrnt sent!');

        });
    };

    

    return (
    <Layout location={location}>
        <Seo 
          title="Contact us"
          location={location} />
      
        <ContactWrapper>   
            <ContactPageTitle>
              <h1>Contact Form</h1>
            </ContactPageTitle>
            <StyledContactForm>
            <form onSubmit={handleOnSubmit}>
              <input type="text" name="name" placeholder="Your Name" required/>

              <input type="email" name="email" placeholder="Your Email" required/>
              <textarea type="text" name="message" placeholder="Your Message" required/>
              <button className={`btn ${Loading ? "active" : "disable"}`} type="submit"> {<LoadingIcon />}<span>Send</span></button>
              <Toaster />

          </form>

         </StyledContactForm>
      </ContactWrapper>
  </Layout>

    );
  };

  export default ContactPage;
